export function formatListInline(
  array: string[],
  type: 'conjunction' | 'disjunction' | 'unit',
  style: 'long' | 'short' | 'narrow' = 'long',
): string {
  return new Intl.ListFormat('en-US', {
    style,
    type,
  }).format(array);
}
